var products = {
  // QDB
  45: {
    src: `https://plugins-media.perfectcorp.com/c27673/sdk.js?apiKey=`,
    token: `CcYz4FDqEPqK7ZYrk9En1w`,
    list: [
      {
        'Product Type': 'Looks',
        'Product Name': 'Classico batom vinho e deline',
        'SKU Name': 'Classico batom vinho e deline',
        'Color Code': '#bf5068',
        'SKU ID': 'look1',
        'Item GUID': 'BCC-28837_20200514_LK_01',
        'Product Look': 'BCC-28837_20200514_LK_01'
      },
      {
        'Product Type': 'Looks',
        'Product Name': 'Colorido chique',
        'SKU Name': 'Colorido chique',
        'Color Code': '#dd716a',
        'SKU ID': 'look2',
        'Item GUID': 'BCC-28837_20200514_LK_02',
        'Product Look': 'BCC-28837_20200514_LK_02'
      },
      {
        'Product Type': 'Looks',
        'Product Name': 'Esfumado com brilho',
        'SKU Name': 'Esfumado com brilho',
        'Color Code': '#a7443b',
        'SKU ID': 'look3',
        'Item GUID': 'BCC-28837_20200514_LK_03',
        'Product Look': 'BCC-28837_20200514_LK_03'
      },
      {
        'Product Type': 'Looks',
        'Product Name': 'Clássico',
        'SKU Name': 'Clássico',
        'Color Code': '#c72822',
        'SKU ID': 'look4',
        'Item GUID': 'BCC-28837_20200514_LK_04',
        'Product Look': 'BCC-28837_20200514_LK_04'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'HOLOGRAFICA ROSALÊS',
        'Color Code': '#cf907e',
        'SKU ID': 77836,
        'Item GUID': 'BCC-28837_20200514_SD_03_13',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE MARRONTERRA',
        'Color Code': '#b4684e',
        'SKU ID': 77837,
        'Item GUID': 'BCC-28837_20200514_SD_03_14',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE VERMERÊ',
        'Color Code': '#a7443b',
        'SKU ID': 77838,
        'Item GUID': 'BCC-28837_20200514_SD_03_15',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'CINTILANTE BEGINHA',
        'Color Code': '#f2d7ac',
        'SKU ID': 77846,
        'Item GUID': 'BCC-28837_20200514_SD_03_16',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Looks',
        'Product Name': 'Make Prática',
        'SKU Name': '',
        'Color Code': '#d9b1a1',
        'SKU ID': 'look5',
        'Item GUID': 'BCC-28837_20200514_LK_05'
      },
      {
        'Product Type': 'Eyebrows 3D',
        'Product Name': 'PALETA SOBRANCE',
        'SKU Name': 'CLARETE',
        'Color Code': '#bc9771',
        'SKU ID': '79445',
        'Item GUID': 'BCC-28837_20200514_BR3D_01_01',
        Creation: '2020-05-14'
      },
      {
        'Product Type': 'Eyebrows 3D',
        'Product Name': 'PALETA SOBRANCE',
        'SKU Name': 'ESCURETE',
        'Color Code': '#877058',
        'SKU ID': '79446',
        'Item GUID': 'BCC-28837_20200514_BR3D_01_02',
        Creation: '2020-05-14'
      },
      {
        'Product Type': 'Face Contour',
        'Product Name': 'ILUMINADOR COMP',
        'SKU Name': 'ROSELUZ',
        'Color Code': '#d9b1a1',
        'SKU ID': '75381',
        'Item GUID': 'BCC-28837_20200514_FCP_01_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Face Contour',
        'Product Name': 'ILUMINADOR COMP',
        'SKU Name': 'OURO',
        'Color Code': '#dfa665',
        'SKU ID': '75382',
        'Item GUID': 'BCC-28837_20200514_FCP_01_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM VOLUMÃO',
        'SKU Name': 'MARSALÊ',
        'Color Code': '#ac5a6a',
        'SKU ID': '72706',
        'Item GUID': 'BCC-28837_20200514_LS_07_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM VOLUMÃO',
        'SKU Name': 'ROSEIRE',
        'Color Code': '#b56c71',
        'SKU ID': '72701',
        'Item GUID': 'BCC-28837_20200514_LS_07_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM VOLUMÃO',
        'SKU Name': 'ROSELELÊ',
        'Color Code': '#cc485c',
        'SKU ID': '76659',
        'Item GUID': 'BCC-28837_20200514_LS_07_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM VOLUMÃO',
        'SKU Name': 'GOIABALÊ',
        'Color Code': '#933d40',
        'SKU ID': '72702',
        'Item GUID': 'BCC-28837_20200514_LS_07_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM VOLUMÃO',
        'SKU Name': 'AMENDOLÊ',
        'Color Code': '#c26258',
        'SKU ID': '72708',
        'Item GUID': 'BCC-28837_20200514_LS_07_05',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'GLOSS SUPERBRIL',
        'SKU Name': 'ROSADEX',
        'Color Code': '#c5839f',
        'SKU ID': '75330',
        'Item GUID': 'BCC-28837_20200514_LS_06_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'GLOSS SUPERBRIL',
        'SKU Name': 'DOURADEX',
        'Color Code': '#ca926e',
        'SKU ID': '75328',
        'Item GUID': 'BCC-28837_20200514_LS_06_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'GLOSS SUPERBRIL',
        'SKU Name': 'MALVALEX',
        'Color Code': '#9e685c',
        'SKU ID': '75329',
        'Item GUID': 'BCC-28837_20200514_LS_06_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM SUPER TIN',
        'SKU Name': 'ROSADOTINT',
        'Color Code': '#bf5068',
        'SKU ID': '75888',
        'Item GUID': 'BCC-28837_20200514_LS_05_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM SUPER TIN',
        'SKU Name': 'NUDETINT',
        'Color Code': '#dd716a',
        'SKU ID': '75889',
        'Item GUID': 'BCC-28837_20200514_LS_05_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM SUPER TIN',
        'SKU Name': 'VERMETINT',
        'Color Code': '#c72822',
        'SKU ID': '75891',
        'Item GUID': 'BCC-28837_20200514_LS_05_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM SUPER TIN',
        'SKU Name': 'MARSALATINT',
        'Color Code': '#a02a31',
        'SKU ID': '75890',
        'Item GUID': 'BCC-28837_20200514_LS_05_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO M',
        'SKU Name': 'NUDELUZ',
        'Color Code': '#ca7c98',
        'SKU ID': '75256',
        'Item GUID': 'BCC-28837_20200514_LS_04_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO M',
        'SKU Name': 'VINHOLUZ',
        'Color Code': '#5a243d',
        'SKU ID': '75258',
        'Item GUID': 'BCC-28837_20200514_LS_04_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO M',
        'SKU Name': 'VERMELUZ',
        'Color Code': '#a64451',
        'SKU ID': '75260',
        'Item GUID': 'BCC-28837_20200514_LS_04_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'ROSÁCIA',
        'Color Code': '#cc5459',
        'SKU ID': '75320',
        'Item GUID': 'BCC-28837_20200514_LS_03_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'ROSETOM',
        'Color Code': '#c5635f',
        'SKU ID': '75319',
        'Item GUID': 'BCC-28837_20200514_LS_03_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'MALVENITO',
        'Color Code': '#cd454f',
        'SKU ID': '75317',
        'Item GUID': 'BCC-28837_20200514_LS_03_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'AMORANDO',
        'Color Code': '#b72354',
        'SKU ID': '75318',
        'Item GUID': 'BCC-28837_20200514_LS_03_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'MARRÔ',
        'Color Code': '#8e4438',
        'SKU ID': '75314',
        'Item GUID': 'BCC-28837_20200514_LS_03_05',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'VERMELHÍSSIMO',
        'Color Code': '#c52f3b',
        'SKU ID': '75312',
        'Item GUID': 'BCC-28837_20200514_LS_03_06',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM MATE ALTA',
        'SKU Name': 'ROXUVA',
        'Color Code': '#a54a68',
        'SKU ID': '75306',
        'Item GUID': 'BCC-28837_20200514_LS_03_07',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'ROSETALI',
        'Color Code': '#b66266',
        'SKU ID': '75228',
        'Item GUID': 'BCC-28837_20200514_LS_02_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'MORENALI',
        'Color Code': '#b36e66',
        'SKU ID': '75226',
        'Item GUID': 'BCC-28837_20200514_LS_02_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'MARRONLI',
        'Color Code': '#9e4931',
        'SKU ID': '75223',
        'Item GUID': 'BCC-28837_20200514_LS_02_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'CASTANHELI',
        'Color Code': '#9c6160',
        'SKU ID': '75225',
        'Item GUID': 'BCC-28837_20200514_LS_02_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'GOIABALI',
        'Color Code': '#ca525b',
        'SKU ID': '75222',
        'Item GUID': 'BCC-28837_20200514_LS_02_05',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'TINTOLI',
        'Color Code': '#613939',
        'SKU ID': '75245',
        'Item GUID': 'BCC-28837_20200514_LS_02_06',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'VINHELI',
        'Color Code': '#9c3636',
        'SKU ID': '75220',
        'Item GUID': 'BCC-28837_20200514_LS_02_07',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'RUBILI',
        'Color Code': '#711731',
        'SKU ID': '75246',
        'Item GUID': 'BCC-28837_20200514_LS_02_08',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'VERMELI',
        'Color Code': '#c83129',
        'SKU ID': '75217',
        'Item GUID': 'BCC-28837_20200514_LS_02_09',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'BEGELI',
        'Color Code': '#be8770',
        'SKU ID': '75238',
        'Item GUID': 'BCC-28837_20200514_LS_02_10',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'CARAMELI',
        'Color Code': '#a95d3b',
        'SKU ID': '75243',
        'Item GUID': 'BCC-28837_20200514_LS_02_11',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'BORDOLI',
        'Color Code': '#783a3b',
        'SKU ID': '75234',
        'Item GUID': 'BCC-28837_20200514_LS_02_12',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'LILALI',
        'Color Code': '#b4676f',
        'SKU ID': '75239',
        'Item GUID': 'BCC-28837_20200514_LS_02_13',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM LÍQUIDO S',
        'SKU Name': 'PIMENTALI',
        'Color Code': '#aa4330',
        'SKU ID': '75247',
        'Item GUID': 'BCC-28837_20200514_LS_02_14',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': 'EXAGERADA',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '77022',
        'Item GUID': 'BCC-28837_20200514_LA_04_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': 'EXTENSÃO DE CÍL',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '79800',
        'Item GUID': 'BCC-28837_20200514_LA_05_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': 'DIVINA',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '77016',
        'Item GUID': 'BCC-28837_20200514_LA_03_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': 'ALONGAMENTO ESC',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '77021',
        'Item GUID': 'BCC-28837_20200514_LA_02_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'LÁPIS BATOM',
        'SKU Name': 'ROSALIZ',
        'Color Code': '#cc7480',
        'SKU ID': '77794',
        'Item GUID': 'BCC-28837_20200514_LS_01_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'LÁPIS BATOM',
        'SKU Name': 'BEGELIZ',
        'Color Code': '#b37570',
        'SKU ID': '77793',
        'Item GUID': 'BCC-28837_20200514_LS_01_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': 'BIG BANG',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '77812',
        'Item GUID': 'BCC-28837_20200514_LA_01_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE VINHÊ',
        'Color Code': '#843f48',
        'SKU ID': '77839',
        'Item GUID': 'BCC-28837_20200514_SD_03_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'CINTILANTE NUDITE',
        'Color Code': '#ffcbbb',
        'SKU ID': '77840',
        'Item GUID': 'BCC-28837_20200514_SD_03_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'CINTILANTE PINKINI',
        'Color Code': '#c96a93',
        'SKU ID': '77849',
        'Item GUID': 'BCC-28837_20200514_SD_03_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE MARSALÊ',
        'Color Code': '#a26156',
        'SKU ID': '77844',
        'Item GUID': 'BCC-28837_20200514_SD_03_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'CINTILANTE ROSEIRINHA',
        'Color Code': '#ffc0bd',
        'SKU ID': '77841',
        'Item GUID': 'BCC-28837_20200514_SD_03_05',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'METALIZADA OURADO',
        'Color Code': '#aa6024',
        'SKU ID': '77843',
        'Item GUID': 'BCC-28837_20200514_SD_03_06',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE PRETÍSSIMA',
        'Color Code': '#30292e',
        'SKU ID': '77842',
        'Item GUID': 'BCC-28837_20200514_SD_03_07',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'HOLOGRÁFICA MARRONLÊS',
        'Color Code': '#ccbe8a',
        'SKU ID': '77853',
        'Item GUID': 'BCC-28837_20200514_SD_03_08',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'ACETINADA CORALZITA',
        'Color Code': '#e76351',
        'SKU ID': '77851',
        'Item GUID': 'BCC-28837_20200514_SD_03_09',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'METALIZADA COBRELUZ',
        'Color Code': '#95583c',
        'SKU ID': '77852',
        'Item GUID': 'BCC-28837_20200514_SD_03_10',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MATE AZULEDA',
        'Color Code': '#49687a',
        'SKU ID': '77877',
        'Item GUID': 'BCC-28837_20200514_SD_03_11',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'SOMBRA',
        'SKU Name': 'GLITTER VERDELÍCIA',
        'Color Code': '#1f231a',
        'SKU ID': '77866',
        'Item GUID': 'BCC-28837_20200514_SD_03_12',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'PALETA SOMBRAS',
        'SKU Name': 'ADORO ROSÊS',
        'Color Code': '#d6a399',
        'SKU ID': '73899',
        'Item GUID': 'BCC-28837_20200514_SD_02_01',
        Creation: '2020-05-13'
      },
      /*#7f4944,#602c2c*/
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'PALETA SOMBRAS',
        'SKU Name': 'ADORO BRONZES',
        'Color Code': '#b97f58',
        'SKU ID': '75886',
        'Item GUID': 'BCC-28837_20200514_SD_02_02',
        Creation: '2020-05-13'
      },
      /*,#af5947,#905a43*/
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'PALETA SOMBRAS',
        'SKU Name': 'ADORO CELEBRAR',
        'Color Code': '#d99895',
        'SKU ID': '77709',
        'Item GUID': 'BCC-28837_20200514_SD_02_03',
        Creation: '2020-05-13'
      },
      /*,#cf9a97,#a67261*/
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'Look',
        'SKU Name': 'Trio',
        'Color Code': '#eeb892',
        'SKU ID': '77842-2',
        'Item GUID': 'BCC-28837_20200514_SD_01_01',
        Creation: '2020-05-13'
      },
      /*,#a26156,#30292e*/
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS ESFUMADOR',
        'SKU Name': 'PRETÔ',
        'Color Code': '#1a1a1a',
        'SKU ID': '77834',
        'Item GUID': 'BCC-28837_20200514_LI_02_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS ESFUMADOR',
        'SKU Name': 'MARRÔ',
        'Color Code': '#48251a',
        'SKU ID': '77835',
        'Item GUID': 'BCC-28837_20200514_LI_02_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'PRETUCO',
        'Color Code': '#1a1a1a',
        'SKU ID': '77814',
        'Item GUID': 'BCC-28837_20200514_LI_01_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'MARRONLITO',
        'Color Code': '#64312a',
        'SKU ID': '77815',
        'Item GUID': 'BCC-28837_20200514_LI_01_02',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'BEGETE',
        'Color Code': '#d9b2a5',
        'SKU ID': '77816',
        'Item GUID': 'BCC-28837_20200514_LI_01_03',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'VERDEZULEX',
        'Color Code': '#4a7669',
        'SKU ID': '77819',
        'Item GUID': 'BCC-28837_20200514_LI_01_04',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'AZULAX',
        'Color Code': '#65b0e6',
        'SKU ID': '77820',
        'Item GUID': 'BCC-28837_20200514_LI_01_05',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'LAPIS OLHOS',
        'SKU Name': 'BRANCOLITO',
        'Color Code': '#ececec',
        'SKU ID': '77818',
        'Item GUID': 'BCC-28837_20200514_LI_01_06',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'PÓ MULTIEFEITOS',
        'SKU Name': '',
        'Color Code': '#e58d90',
        'SKU ID': '28825',
        'Item GUID': 'BCC-28837_20200514_BL_01_01',
        Creation: '2020-05-13'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'MALVADA',
        'Color Code': '#a35458',
        'SKU ID': '75300',
        'Item GUID': 'BCC-28837_20200511_LS_01_01',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'MALVELITA',
        'Color Code': '#b36c5f',
        'SKU ID': '75298',
        'Item GUID': 'BCC-28837_20200511_LS_01_02',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'MARRONZÍSSIMO',
        'Color Code': '#814a39',
        'SKU ID': '75299',
        'Item GUID': 'BCC-28837_20200511_LS_01_03',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'NUDETE',
        'Color Code': '#cb9f88',
        'SKU ID': '75294',
        'Item GUID': 'BCC-28837_20200511_LS_01_04',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'VINHETE',
        'Color Code': '#ab7180',
        'SKU ID': '75293',
        'Item GUID': 'BCC-28837_20200511_LS_01_05',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'ROSARÃO',
        'Color Code': '#d58a8b',
        'SKU ID': '75292',
        'Item GUID': 'BCC-28837_20200511_LS_01_06',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Lip Color',
        'Product Name': 'BATOM HIDRATANT',
        'SKU Name': 'VERMELHADO',
        'Color Code': '#97362f',
        'SKU ID': '75286',
        'Item GUID': 'BCC-28837_20200511_LS_01_07',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Eye Liner',
        'Product Name': 'CANETA DELINEADORA',
        'SKU Name': 'FININHA',
        'Color Code': '#1a1a1a',
        'SKU ID': '77918',
        'Item GUID': 'BCC-28837_20200511_LI_01_01',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'BLUSH COMPACTO',
        'SKU Name': 'ROSADINHA',
        'Color Code': '#b0797b',
        'SKU ID': '18333',
        'Item GUID': 'BCC-28837_20200511_BL_01_01',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'BLUSH COMPACTO',
        'SKU Name': 'CASTANHEX',
        'Color Code': '#bb8b71',
        'SKU ID': '75393',
        'Item GUID': 'BCC-28837_20200511_BL_01_02',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'BLUSH COMPACTO',
        'SKU Name': 'MALVÍSSIMA',
        'Color Code': '#d1998e',
        'SKU ID': '75386',
        'Item GUID': 'BCC-28837_20200511_BL_01_03',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'BLUSH COMPACTO',
        'SKU Name': 'ALARANJADO',
        'Color Code': '#d99a6a',
        'SKU ID': '75385',
        'Item GUID': 'BCC-28837_20200511_BL_01_04',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Blush',
        'Product Name': 'BLUSH COMPACTO',
        'SKU Name': 'ROSITA',
        'Color Code': '#df9783',
        'SKU ID': '75383',
        'Item GUID': 'BCC-28837_20200511_BL_01_05',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'GLITTER',
        'SKU Name': 'DOURATIX',
        'Color Code': '#d7ad88',
        'SKU ID': '76661',
        'Item GUID': 'BCC-28837_20200511_SD_01_01',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Eye Shadow',
        'Product Name': 'GLITTER',
        'SKU Name': 'ROSATIX',
        'Color Code': '#d37684',
        'SKU ID': '76663',
        'Item GUID': 'BCC-28837_20200511_SD_01_02',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Mascara',
        'Product Name': '4D',
        'SKU Name': 'PRETA',
        'Color Code': '#000000',
        'SKU ID': '77310',
        'Item GUID': 'BCC-28837_20200511_LA_01_01',
        Creation: '2020-05-11'
      },
      {
        'Product Type': 'Face Contour',
        'Product Name': '7891033288250',
        'SKU Name': 'PÓ MULTIEFEITOS',
        'Color Code': '#dfc0a2,#cc9c6f',
        'SKU ID': '28825-1',
        'Item GUID': 'BCC-28837_20200511_FCP_01_01',
        Creation: '2020-05-11'
      }
    ]
  },

  // BOT
  47: {
    src: `https://plugins-media.perfectcorp.com/c14391/sdk.js?apiKey=`,
    token: `b9LKuuz6Zux5CJ0YG2RUw==`,
    list: [
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#8D4441',
        'SKU ID': '77295',
        'Item GUID': 'BCC-20858_20191106_LS_05_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM HIDRATANTE CREMOSO',
        'Color Code': '#BE8085',
        'SKU ID': '73441',
        'Item GUID': 'BCC-20858_20191106_LS_01_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#C95671',
        'SKU ID': '77283',
        'Item GUID': 'BCC-20858_20200304_LS_01_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#A9245E',
        'SKU ID': '73422',
        'Item GUID': 'BCC-20858_20191106_LS_01_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#91588F',
        'SKU ID': '75980',
        'Item GUID': 'BCC-20858_20191106_LS_01_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#A84A5C',
        'SKU ID': '73425',
        'Item GUID': 'BCC-20858_20191112_LS_01_12',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE SUPER FRESH! BATOM LÍQUIDO EFEITO NATURAL',
        'Color Code': '#C57175',
        'SKU ID': '73874',
        'Item GUID': 'BCC-20858_20191112_LS_06_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'MAKE B BATOM LÍQUIDO MATE, 5 ML',
        'Color Code': '#9e352c',
        'SKU ID': '77305',
        'Item GUID': 'BCC-20858_20190514_LS_02_13',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HIDRATANTE',
        'SKU Name': 'MAKE B BATOM HIDRATANTE, 3,6 G',
        'Color Code': '#993f3b',
        'SKU ID': '81143',
        'Item GUID': 'BCC-20858_20200304_LS_02_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#804000',
        'SKU ID': '77276',
        'Item GUID': 'BCC-20858_20190514_LS_04_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM GLOSS',
        'SKU Name': 'MAKE B GLOSS LABIAL, 5 ML',
        'Color Code': '#4b1f31',
        'SKU ID': '77321',
        'Item GUID': 'BCC-20858_20190514_LS_08_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HYALURONIC',
        'SKU Name': 'MAKE B. BATOM STICK HYALURONIC',
        'Color Code': '#8a0000',
        'SKU ID': '75743',
        'Item GUID': 'BCC-20858_20191106_LS_04_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM ACETINADO',
        'SKU Name': 'INTENSE BATOM ACETINADO',
        'Color Code': '#cc7494',
        'SKU ID': '74897',
        'Item GUID': 'BCC-20858_20191106_LS_03_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'INTENSE BATOM LÍQUIDO MATE',
        'Color Code': '#a4001e',
        'SKU ID': '73434',
        'Item GUID': 'BCC-20858_20191112_LS_03_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#4e1e1c',
        'SKU ID': '76638',
        'Item GUID': 'BCC-20858_20191112_LS_01_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÁPIS BATOM',
        'SKU Name': 'INTENSE LAPIS BATOM INSTALIP PAPRICA 1,2 G',
        'Color Code': '#bf342b',
        'SKU ID': '80820',
        'Item GUID': 'BCC-20858_20191112_LS_02_07',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÁPIS BATOM',
        'SKU Name': 'INTENSE LAPIS BATOM INSTALIP VINHO 1,2 G',
        'Color Code': '#8f2041',
        'SKU ID': '80821',
        'Item GUID': 'BCC-20858_20191112_LS_02_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Eye Liner',
        Category: 'LÁPIS',
        'Product Name': 'LÁPIS',
        'SKU Name': 'MAKE B. LÁPIS PARA OLHOS GEL ULTRABLACK',
        'Color Code': '#000000',
        'SKU ID': '27861',
        'Item GUID': 'BCC-20858_20190514_LI_02_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': '',
        Category: 'DELINEADOR',
        'Product Name': 'DELINEADOR',
        'SKU Name': 'MAKE B. CANETA DELINEADORA PARA OLHOS PONTA FINA PRETA, 1,2ML',
        'Color Code': '#000000',
        'SKU ID': '76689',
        'Item GUID': 'BCC-20858_20190514_LI_01_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#af6a3e',
        'SKU ID': '76078',
        'Item GUID': 'BCC-20858_20191112_LS_04_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Blush',
        Category: 'BLUSH',
        'Product Name': 'BLUSH',
        'SKU Name': 'MAKE B. HIT PALETA BLUSH PINK, 8G',
        'Color Code': '#ff8d54',
        'SKU ID': '75495',
        'Item GUID': 'BCC-20858_20190514_BL_01_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': undefined,
        Category: 'MÁSCARA',
        'Product Name': 'MÁSCARA',
        'SKU Name': 'MAKE B. MÁSCARA EXPLOSION EFFECT',
        'Color Code': '#000000',
        'SKU ID': '73708',
        'Item GUID': 'BCC-20858_20190514_LA_03_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': undefined,
        Category: 'SOMBRA',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MAKE B. SOMBRA FOIL MULTIEFEITO DIAMOND FANCY 4G',
        'Color Code': '#8a2417',
        'SKU ID': '26903',
        'Item GUID': 'BCC-20858_20190514_SD_02_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': undefined,
        Category: 'SOMBRA',
        'Product Name': 'SOMBRA',
        'SKU Name': 'MAKE B. SOMBRA FOIL MULTIEFEITO DIAMOND RADIANCE 4G',
        'Color Code': '#976c55',
        'SKU ID': '26908',
        'Item GUID': 'BCC-20858_20190514_SD_02_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#C57C6D',
        'SKU ID': '77288',
        'Item GUID': 'BCC-20858_20191106_LS_05_11',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM HIDRATANTE CREMOSO',
        'Color Code': '#8D565F',
        'SKU ID': '74901',
        'Item GUID': 'BCC-20858_20191106_LS_01_08',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#AF5F6F',
        'SKU ID': '73415',
        'Item GUID': 'BCC-20858_20191106_LS_01_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#9D284B',
        'SKU ID': '77322',
        'Item GUID': 'BCC-20858_20200304_LS_01_07',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#691419',
        'SKU ID': '73430',
        'Item GUID': 'BCC-20858_20191112_LS_01_10',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE SUPER FRESH! BATOM LÍQUIDO EFEITO NATURAL',
        'Color Code': '#9f393f',
        'SKU ID': '73875',
        'Item GUID': 'BCC-20858_20191112_LS_06_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'MAKE B BATOM LÍQUIDO MATE, 5 ML',
        'Color Code': '#ba5270',
        'SKU ID': '77301',
        'Item GUID': 'BCC-20858_20190514_LS_02_14',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HIDRATANTE',
        'SKU Name': 'MAKE B BATOM HIDRATANTE, 3,6 G',
        'Color Code': '#ac021b',
        'SKU ID': '81145',
        'Item GUID': 'BCC-20858_20200304_LS_02_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#a6163f',
        'SKU ID': '77275',
        'Item GUID': 'BCC-20858_20190514_LS_04_10',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM GLOSS',
        'SKU Name': 'MAKE B GLOSS LABIAL, 5 ML',
        'Color Code': '#88455f',
        'SKU ID': '80816',
        'Item GUID': 'BCC-20858_20190514_LS_08_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM ACETINADO',
        'SKU Name': 'INTENSE BATOM ACETINADO',
        'Color Code': '#c8777a',
        'SKU ID': '74896',
        'Item GUID': 'BCC-20858_20191106_LS_03_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HYALURONIC',
        'SKU Name': 'MAKE B. BATOM STICK HYALURONIC',
        'Color Code': '#964947',
        'SKU ID': '75744',
        'Item GUID': 'BCC-20858_20191106_LS_04_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#903367',
        'SKU ID': '73416',
        'Item GUID': 'BCC-20858_20191106_LS_01_06',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'INTENSE BATOM LÍQUIDO MATE',
        'Color Code': '#87514d',
        'SKU ID': '73439',
        'Item GUID': 'BCC-20858_20191112_LS_03_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#50202f',
        'SKU ID': '77281',
        'Item GUID': 'BCC-20858_20200304_LS_01_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#955767',
        'SKU ID': '74899',
        'Item GUID': 'BCC-20858_20191112_LS_01_09',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#af5659',
        'SKU ID': '76081',
        'Item GUID': 'BCC-20858_20191112_LS_05_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#925E66',
        'SKU ID': '80811',
        'Item GUID': 'BCC-20858_20191106_LS_05_15',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM ACETINADO',
        'SKU Name': 'INTENSE BATOM ACETINADO',
        'Color Code': '#86544a',
        'SKU ID': '74898',
        'Item GUID': 'BCC-20858_20191106_LS_03_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#4f254e',
        'SKU ID': '73426',
        'Item GUID': 'BCC-20858_20191112_LS_01_06',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'MAKE B BATOM LÍQUIDO MATE, 5 ML',
        'Color Code': '#b50028',
        'SKU ID': '77302',
        'Item GUID': 'BCC-20858_20190514_LS_02_12',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HIDRATANTE',
        'SKU Name': 'MAKE B BATOM HIDRATANTE, 3,6 G',
        'Color Code': '#6f1844',
        'SKU ID': '81146',
        'Item GUID': 'BCC-20858_20200304_LS_02_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#de698c',
        'SKU ID': '77280',
        'Item GUID': 'BCC-20858_20190514_LS_04_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#ae7074',
        'SKU ID': '77306',
        'Item GUID': 'BCC-20858_20200304_LS_01_06',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HYALURONIC',
        'SKU Name': 'MAKE B. BATOM STICK HYALURONIC',
        'Color Code': '#9c646c',
        'SKU ID': '75745',
        'Item GUID': 'BCC-20858_20191106_LS_04_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#9c2b24',
        'SKU ID': '73410',
        'Item GUID': 'BCC-20858_20191106_LS_01_15',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'MAKE B BATOM LÍQUIDO MATE, 5 ML',
        'Color Code': '#cd6c7c',
        'SKU ID': '77304',
        'Item GUID': 'BCC-20858_20190514_LS_02_11',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'INTENSE BATOM LÍQUIDO MATE',
        'Color Code': '#7e4a5a',
        'SKU ID': '73445',
        'Item GUID': 'BCC-20858_20191112_LS_03_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#d97b81',
        'SKU ID': '76075',
        'Item GUID': 'BCC-20858_20191112_LS_04_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#8c4a2d',
        'SKU ID': '77287',
        'Item GUID': 'BCC-20858_20191106_LS_05_09',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#d86e6f',
        'SKU ID': '77277',
        'Item GUID': 'BCC-20858_20190514_LS_04_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#9a2533',
        'SKU ID': '80695',
        'Item GUID': 'BCC-20858_20200304_LS_01_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HYALURONIC',
        'SKU Name': 'MAKE B. BATOM STICK HYALURONIC',
        'Color Code': '#994043',
        'SKU ID': '75746',
        'Item GUID': 'BCC-20858_20191106_LS_04_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#9b524a',
        'SKU ID': '73424',
        'Item GUID': 'BCC-20858_20191112_LS_01_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#b21550',
        'SKU ID': '77299',
        'Item GUID': 'BCC-20858_20191106_LS_05_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#c96f74',
        'SKU ID': '77278',
        'Item GUID': 'BCC-20858_20190514_LS_04_11',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#ab0d36',
        'SKU ID': '73427',
        'Item GUID': 'BCC-20858_20191112_LS_01_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#c06e72',
        'SKU ID': '73414',
        'Item GUID': 'BCC-20858_20191106_LS_01_01',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO MATE',
        'SKU Name': 'MAKE B BATOM LÍQUIDO MATE, 5 ML',
        'Color Code': '#bf0e5d',
        'SKU ID': '77307',
        'Item GUID': 'BCC-20858_20190514_LS_02_10',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#c97b7b',
        'SKU ID': '76083',
        'Item GUID': 'BCC-20858_20191112_LS_05_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#7f0027',
        'SKU ID': '80696',
        'Item GUID': 'BCC-20858_20200304_LS_01_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#bb5899',
        'SKU ID': '77284',
        'Item GUID': 'BCC-20858_20190514_LS_04_09',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM HYALURONIC',
        'SKU Name': 'MAKE B. BATOM STICK HYALURONIC',
        'Color Code': '#831846',
        'SKU ID': '75747',
        'Item GUID': 'BCC-20858_20191106_LS_04_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#d24d5e',
        'SKU ID': '76079',
        'Item GUID': 'BCC-20858_20191112_LS_04_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#b97d84',
        'SKU ID': '77285',
        'Item GUID': 'BCC-20858_20190514_LS_04_05',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#a4292c',
        'SKU ID': '77318',
        'Item GUID': 'BCC-20858_20191106_LS_05_02',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'INTENSE BATOM MATE',
        'Color Code': '#8a0b2b',
        'SKU ID': '73428',
        'Item GUID': 'BCC-20858_20191112_LS_01_07',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#784b52',
        'SKU ID': '73417',
        'Item GUID': 'BCC-20858_20191106_LS_01_17',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#c90b00',
        'SKU ID': '77289',
        'Item GUID': 'BCC-20858_20191106_LS_05_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM LÍQUIDO METÁLICO',
        'SKU Name': 'MAKE B. BATOM LÍQUIDO METÁLICO, 5 ML',
        'Color Code': '#915d5d',
        'SKU ID': '80812',
        'Item GUID': 'BCC-20858_20200304_LS_01_04',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM EFEITO NATURAL',
        'SKU Name': 'INTENSE BATOM SUPER FRESH! EFEITO NATURAL',
        'Color Code': '#e08c7d',
        'SKU ID': '76080',
        'Item GUID': 'BCC-20858_20191112_LS_05_03',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#60002c',
        'SKU ID': '77291',
        'Item GUID': 'BCC-20858_20190514_LS_04_13',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#910d31',
        'SKU ID': '73423',
        'Item GUID': 'BCC-20858_20191106_LS_01_07',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#a0002c',
        'SKU ID': '77296',
        'Item GUID': 'BCC-20858_20190514_LS_04_08',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#790f46',
        'SKU ID': '77290',
        'Item GUID': 'BCC-20858_20191106_LS_05_16',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'INTENSE BATOM CREMOSO',
        'Color Code': '#661424',
        'SKU ID': '76636',
        'Item GUID': 'BCC-20858_20191106_LS_01_10',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#8f0018',
        'SKU ID': '77297',
        'Item GUID': 'BCC-20858_20190514_LS_04_07',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#e07f9c',
        'SKU ID': '77292',
        'Item GUID': 'BCC-20858_20191106_LS_05_12',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#5b0011',
        'SKU ID': '77319',
        'Item GUID': 'BCC-20858_20190514_LS_04_06',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM CREMOSO',
        'SKU Name': 'MAKE B. BATOM CREMOSO 3,6 G',
        'Color Code': '#c52c1a',
        'SKU ID': '81142',
        'Item GUID': 'BCC-20858_20190514_LS_04_12',
        Creation: '18/05/2020'
      },
      {
        'Product Type': 'Lip Color',
        Category: 'BATOM',
        'Product Name': 'BATOM MATE',
        'SKU Name': 'MAKE B. BATOM MATE, 3,6 G',
        'Color Code': '#9d6e82',
        'SKU ID': '77298',
        'Item GUID': 'BCC-20858_20191106_LS_05_08',
        Creation: '18/05/2020'
      }
    ]
  }
};

module.exports = products;
